import {
  PACKING_RECOMMENDATION_APPLIED,
  PACKING_RECOMMENDATION_DISMISSED,
  PACKING_RECOMMENDATION_OVERRIDDEN,
  PACKING_RECOMMENDATION_REQUESTED,
  PACKING_RECOMMENDATION_RERUN_CLICKED,
  PACKING_RECOMMENDATION_SHOWN,
  PACKING_RECOMMENDATION_WARNING_ACKNOWLEDGED,
} from '../../constants/analytics-events';
import type { PackingEnforcementMode } from '../enforcement/constants';
import { Segment } from '../../services/analytics-services/segment';

export const trackPackingRecommendationRequested = (fulfillmentPlanId: string, optimizationFactor: string): void => {
  Segment.trackEvent(PACKING_RECOMMENDATION_REQUESTED, {
    fulfillmentPlanId,
    optimizationFactor,
  });
};

export const trackPackingRecommendationShown = (
  fulfillmentPlanId: string,
  packageName: string,
  isMultiBox: boolean,
  boxCount: number,
): void => {
  Segment.trackEvent(PACKING_RECOMMENDATION_SHOWN, {
    fulfillmentPlanId,
    packageName,
    isMultiBox,
    boxCount,
  });
};

export const trackPackingRecommendationApplied = (
  fulfillmentPlanId: string,
  packageName: string,
  isMultiBox: boolean,
  boxCount: number,
): void => {
  Segment.trackEvent(PACKING_RECOMMENDATION_APPLIED, {
    fulfillmentPlanId,
    packageName,
    isMultiBox,
    boxCount,
  });
};

export const trackPackingRecommendationDismissed = (fulfillmentPlanId: string, packageName: string): void => {
  Segment.trackEvent(PACKING_RECOMMENDATION_DISMISSED, {
    fulfillmentPlanId,
    packageName,
  });
};

export const trackPackingRecommendationRerunClicked = (fulfillmentPlanId: string, optimizationFactor: string): void => {
  Segment.trackEvent(PACKING_RECOMMENDATION_RERUN_CLICKED, {
    fulfillmentPlanId,
    optimizationFactor,
  });
};

// The free-text override reason is never sent to Segment — only the enforcement mode and outcome.
export const trackPackingRecommendationOverridden = (fulfillmentPlanId: string, mode: PackingEnforcementMode): void => {
  Segment.trackEvent(PACKING_RECOMMENDATION_OVERRIDDEN, {
    fulfillmentPlanId,
    mode,
  });
};

export const trackPackingRecommendationWarningAcknowledged = (fulfillmentPlanId: string): void => {
  Segment.trackEvent(PACKING_RECOMMENDATION_WARNING_ACKNOWLEDGED, {
    fulfillmentPlanId,
  });
};
